<div class="flex flex-col overflow-y-auto py-24px">
  <h2 class="text-secondary">{{ 'base.balances' | transloco }}</h2>
  <ib-dashboard-balances class="block mt-8px"></ib-dashboard-balances>

  <h2 class="mt-36px text-secondary">{{ 'base.transactions' | transloco }}</h2>
  <ib-dashboard-transactions
    class="relative mt-8px block md:shadow-wdgt md:rounded-wdgt md:rounded-wdgt md:border md:border-border-d md:rounded-6px"
  ></ib-dashboard-transactions>

  <ib-dashboard-credit-account-modal
    *ngIf="isTransferModalShow$ | async"
    (closeMe)="closeTranferModal()"
  ></ib-dashboard-credit-account-modal>

  <ib-dashboard-add-document-modal
    *ngIf="isAddDocsModalShow$ | async"
    (closeMe)="closeAddDocModal()"
  ></ib-dashboard-add-document-modal>
</div>
